import { useOwnedTopicsTabModel } from './owned-topics-tab.model'
import { OwnedTopicsTabView } from './owned-topics-tab.view'

export const OwnedTopicsTab = () => {
  const ownedTopicsTabModel = useOwnedTopicsTabModel()
  return <OwnedTopicsTabView {...ownedTopicsTabModel} />
}
